import { useMutation } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import { getPrivateInstance } from "../_privateInstance";
import { extractDownloadData } from "../presignedDownload";

export type DownloadFlaggedUsersPayload = {
  /** Inclusive start date in `YYYY-MM-DD`. */
  start_date: string;
  /** Inclusive end date in `YYYY-MM-DD`. */
  end_date: string;
};

export type DownloadFlaggedUsersResponse = {
  download_url: string;
  file_name: string;
  row_count: number;
  expires_in: number;
} | null;

const downloadFlaggedUsers = async (
  payload: DownloadFlaggedUsersPayload,
): Promise<DownloadFlaggedUsersResponse> => {
  const response = await getPrivateInstance().post(
    API_ROUTES.POST_FRAUD_FLAGGED_USERS_DOWNLOAD,
    payload,
  );

  const data = extractDownloadData(response);
  if (!data) return null;

  // This view treats a missing count/TTL as zero (the table uses
  // `row_count === 0` to short-circuit an empty export).
  return {
    download_url: data.download_url,
    file_name: data.file_name ?? "",
    row_count: data.row_count ?? 0,
    expires_in: data.expires_in ?? 0,
  };
};

export const useDownloadFlaggedUsers = () =>
  useMutation<
    DownloadFlaggedUsersResponse,
    Error,
    DownloadFlaggedUsersPayload
  >({
    mutationKey: ["POST_FRAUD_FLAGGED_USERS_DOWNLOAD"],
    mutationFn: downloadFlaggedUsers,
  });
